import React from 'react';
import PropTypes from 'prop-types';

import { contentSvgs } from 'assets/icons';

import TooltipContainer from './TooltipContainer';

import * as S from './styles';

const Tooltip = ({ headText, children, position }) => (
  <S.Container>
    <S.Icon>{contentSvgs('information')}</S.Icon>
    <TooltipContainer position={position} headText={headText}>
      {children}
    </TooltipContainer>
  </S.Container>
);

export default Tooltip;

Tooltip.defaultProps = {
  headText: '',
  position: 'left',
};

Tooltip.propTypes = {
  headText: PropTypes.string,
  children: PropTypes.node.isRequired,
  position: PropTypes.string,
};
